"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

/**
 * Module dependencies.
 */

/**
 * `modalFadeInUp` keyframes.
 */
var modalFadeInUp = (0, _styledComponents.keyframes)(["from{opacity:0;transform:translate3d(0,16px,0);}25%{opacity:0;}to{opacity:1;}"]);
/**
 * `fadeInDown` keyframes.
 */

var fadeInDown = (0, _styledComponents.keyframes)(["from{opacity:0;transform:translate3d(0,-100%,0);}to{opacity:1;transform:translate3d(0,0,0);}"]);
/**
 * `fadeIn` keyframes.
 */

var fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
/**
 * `fadeOut` keyframes.
 */

var fadeOut = (0, _styledComponents.keyframes)(["from{opacity:1;}to{opacity:0;}"]);
/**
 * `pulse` keyframes.
 */

var pulse = (0, _styledComponents.keyframes)(["from{transform:scale(0.4);}to{transform:scale(1);}"]);
/**
 * Export `keyframes`.
 */

var _default = {
  fadeIn: fadeIn,
  fadeInDown: fadeInDown,
  fadeOut: fadeOut,
  modalFadeInUp: modalFadeInUp,
  pulse: pulse
};
exports["default"] = _default;